export function loadStylesheet(url: string, id: string) {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = url;
  link.id = id;
  document.head.appendChild(link);
}

export function loadScript(url: string, onLoad: () => void) {
  const script = document.createElement("script");
  script.src = url;
  script.onload = onLoad;
  document.head.appendChild(script);
}
